import React, { PureComponent } from 'react';
import ImagenPrincipal from '../assets/portada.png';
import { Fade } from 'react-awesome-reveal';

export default class Inicio extends PureComponent {
  render() {
    return (
      <header id="inicio" className="section__container header__container">
        <Fade triggerOnce>
          <div className="header__content">
            <p className="txtAgencia">AGENCIA DE MARKETING Y COMMUNITY MANAGER</p>

            <h1>
              <span>TÚ PUEDES</span> LOGRARLO
            </h1>

            <p className="header__description">
              Nos encargamos de que tu empresa
              <span style={{ color: 'orange', fontWeight: 'bold' }}> DESTAQUE </span>
              frente a la competencia
              <span style={{ color: 'orange', fontWeight: 'bold' }}> DIFERENCIÁNDOTE </span>
              en tu sector.
            </p>

            <button
              className="btn_nosotrosTeAyudamos"
              onClick={() =>
                document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              Nosotros te ayudamos
            </button>
          </div>

          <div className="header__image">
            <div className="header__image-glow"></div>
            <img src={ImagenPrincipal} alt="Imagen principal" />
          </div>
        </Fade>
      </header>
    );
  }
}